export function slashSuggester(registry) {
    return {
        noDecorations: true,
        char: "/",
        name: "command-suggestion",
        supportedCharacters: /\w[^/]*/,
        createCommand: ({ match, view }) => {
            return (commandSpec) => {
                commandSpec.command(match, view);
                view.focus();
            };
        },
        ...registry.callbacks,
    };
}
